import { render, staticRenderFns } from "./SalarioMinimoEditar.vue?vue&type=template&id=03d75c19&"
import script from "./SalarioMinimoEditar.vue?vue&type=script&lang=js&"
export * from "./SalarioMinimoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports